import React from 'react'
import moment from 'moment'

// containers
import ModalWrapper from 'components/shared/ModalWrapper'

// components
import Paragraph from 'components/atoms/Paragraph'

// helpers
import { centsToDollars } from 'lib/helpers/money'

const SummerPassProductInfo = props => {
  const { product, session, modalId, modalTitle, volumeDiscountPriceCents } =
    props

  // props for retail products
  const refundDate = moment(session.refundDate).format('MMMM D, YYYY')

  return (
    <ModalWrapper title={modalTitle} modalId={modalId} closeButton>
      <>
        <Paragraph>
          Covers unlimited attendance for one camper, including all hours,
          materials and food.
        </Paragraph>

        <Paragraph>
          Your camper is guaranteed space any day at any location, and there is
          no need to reserve dates in advance.
        </Paragraph>

        <Paragraph>
          One camper per {product.unlimitedDescription}. Non-transferable.
        </Paragraph>

        <Paragraph>
          {product.unlimitedDescription} is only valid for {session.name}{' '}
          {session.year} and is not transferable to another session.
        </Paragraph>

        <Paragraph>
          If your camper uses less than {product.breakEvenDays} days after
          purchasing a {product.unlimitedDescription}, we'll calculate what you
          would have paid at {centsToDollars(volumeDiscountPriceCents)}/day and
          refund the difference automatically on {refundDate}.
        </Paragraph>

        <Paragraph>
          Previous purchases of Day Passes, used or unused, can be applied
          towards a {product.unlimitedDescription}.
        </Paragraph>
      </>
    </ModalWrapper>
  )
}

export default SummerPassProductInfo
